import axios from "axios";
import rutas from "@/assets/utils/rutas.json";

const getCommentsByAtencion = async (tokenAtencion) => {
  if (!tokenAtencion) {
    console.error("token atencion es requerido");
    return null;
  }

  const query = `
    query AllAtenmedica(
      $tokenAtencion:String
    ) {
    allAtenmedica(
      tokenAtencion:$tokenAtencion
    ) {
        total
        atcm {
          id
          token
          comentarioatencionmedicaSet {
            id
            token
            idForanea
            tablaForanea
            comentario
            estadoComentario,
            ultimoCambio
            usuarioCreador {
              id
              username
              firstName
              lastName
            }
          }
        }
      }
    }
  `;

  const variables = {
    tokenAtencion,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });
    const response2 = response.data.data.allAtenmedica;

    if (response2.atcm.length === 0) return null;
    if (response2.atcm[0].comentarioatencionmedicaSet.length === 0) return null;

    const data = response2.atcm[0].comentarioatencionmedicaSet;

    return data;
  } catch (error) {
    console.error(error);
    return error;
  }
};

const getCommentsValidacionByAtencion = async (tokenAtencion) => {
  if (!tokenAtencion) {
    console.error("token atencion es requerido");
    return null;
  }

  const query = `
    query AllAtenmedica($tokenAtencion: String) {
      allAtenmedica(tokenAtencion: $tokenAtencion) {
        total
        atcm {
          id
          token
          comentariovalidacionatencionSet {
            id
            token
            comentario
            estadoComentario
            ultimoCambio
            usuarioCreador {
              id
              username
              firstName
              lastName
            }
          }
        }
      }
    }
  `;

  const variables = {
    tokenAtencion,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });
    const response2 = response.data.data.allAtenmedica;

    if (response2.atcm.length === 0) return null;
    if (response2.atcm[0].comentariovalidacionatencionSet.length === 0)
      return null;

    const data = response2.atcm[0].comentariovalidacionatencionSet;
    return data;
  } catch (error) {
    console.error("no se pudieron obterner los comentarios", error);
    return error;
  }
};

const updateComentarioValidacion = async (tokenAtencion, dataComentario) => {
  if (!tokenAtencion) {
    console.error("token atencion es requerido");
    return null;
  }

  const query = `
    mutation AddComentarioValidacion(
      $tokenAtencion: String!,
      $tokenComentario: String,
      $comentario: String,
      $estadoComentario: String
    ) {
      addComentarioValidacion(
        tokenAtencion: $tokenAtencion,
        tokenComentario: $tokenComentario,
        comentario: $comentario
        estadoComentario: $estadoComentario
      ) {
        message
        status
        comentario {
          id
          token
        }
      }
    }  
  `;

  const variables = {
    tokenAtencion,
    tokenComentario: dataComentario.token || "",
    comentario: dataComentario.comentario,
    estadoComentario: dataComentario.token
      ? dataComentario.estadoComentario
      : "1",
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    const response2 = response.data.data.addComentarioValidacion;

    if (response2.status !== 200) return null;

    const data = response2.comentario?.token;
    return data;
  } catch (error) {
    console.error(error);
    return error;
  }
};

const addComentarioAuditoria = async (tokenAtencion, comentario) => {
  if (!tokenAtencion) {
    console.error("token atencion es requerido");
    return null;
  }

  const query = `
    mutation addComentarioAuditoria(
      $tokenAtencion: String!,
      $comentarios: String!
    ) {
      addComentarioAuditoria(
        tokenAtencion: $tokenAtencion,
        comentarios: $comentarios
      ) {
        message
        status
        atencionAuditada {
          id
          token
          comentariosauditoria
          estadoauditoria
        }
      }
    }
  `;

  const variables = {
    tokenAtencion,
    comentarios: comentario,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    const result = response.data.data.addComentarioAuditoria;

    if (result.status !== "success") return null;

    return result.atencionAuditada;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const changeToValidadoAuditoria = async (tokenAtencion) => {
  if (!tokenAtencion) {
    console.error("token atencion es requerido");
    return null;
  }

  const query = `
    mutation changeToValidadoAuditoria(
      $tokenAtencion: String!,
    
    ) {
      changeToValidadoAuditoria(
        tokenAtencion: $tokenAtencion
       
      ) {
        message
        status
        atencionAuditada {
          id
          token
          comentariosauditoria
          estadoauditoria
        }
      }
    }
  `;

  const variables = {
    tokenAtencion
   
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    const result = response.data.data.changeToValidadoAuditoria;

    if (result.status !== "success") return null;

    return result.atencionAuditada;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const changeToCorregidoAuditoria = async (tokenAtencion) => {
  if (!tokenAtencion) {
    console.error("token atencion es requerido");
    return null;
  }

  const query = `
    mutation changeToCorregidoAuditoria(
      $tokenAtencion: String!,
    
    ) {
      changeToCorregidoAuditoria(
        tokenAtencion: $tokenAtencion
       
      ) {
        message
        status
        atencionAuditada {
          id
          token
          comentariosauditoria
          estadoauditoria
        }
      }
    }
  `;

  const variables = {
    tokenAtencion
   
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    const result = response.data.data.changeToCorregidoAuditoria;

    if (result.status !== "success") return null;

    return result.atencionAuditada;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const consultarComentariosAuditoria = async (tokenAtencion) => {
  if (!tokenAtencion) {
    console.error("token atencion es requerido");
    return null;
  }

  const query = `
    query consultarComentariosAuditoria(
      $tokenAtencion: String!,
      
    ) {
      consultarComentariosAuditoria(
        tokenAtencion: $tokenAtencion,
       
      ) {
      
          
          id
          token
          comentariosauditoria
          estadoauditoria
        
      }
    }
  `;

  const variables = {
    tokenAtencion,
    
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    const result = response.data.data.consultarComentariosAuditoria;

    if (!result) return null;

    return result;
  } catch (error) {
    console.error(error);
    return null;
  }
};


const consultarCantidadComentariosAuditoria = async (idDoctor) => {
  if (!idDoctor) {
    console.error("idDoctor es requerido");
    return null;
  }

  const query = `
    query consultarCantidadComentariosAuditoria(
      $idDoctor: ID!,
      
    ) {
      consultarCantidadComentariosAuditoria(
        idDoctor: $idDoctor,
       
      ) {
          atencionesAuditadas {
            id
            token
            comentariosauditoria
            estadoauditoria
            auditorUser {
            username
            }
            cita {
            fechaCita
            paciente {
            persona {
            primerApellido
            primerNombre
            identificacion
            }}
            }
          }
          cantidad
          status
          message
       
        
      }
    }
  `;

  const variables = {
    idDoctor,
    
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    const result = response.data.data.consultarCantidadComentariosAuditoria;

    console.log("RESULTADOS REVISON COMENTARIOS", result)

    if (!result) return null;

    return result;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const consultarCantidadComentariosByAuditor = async (idUser) => {
  if (!idUser) {
    console.error("idDoctor es requerido");
    return null;
  }

  const query = `
    query consultarCantidadComentariosByAuditor(
      $idUser: ID!,
      
    ) {
      consultarCantidadComentariosByAuditor(
        idUser: $idUser,
       
      ) {
          atencionesAuditadas {
            id
            token
            comentariosauditoria
            estadoauditoria
            auditorUser {
            username
            }
            cita {
            fechaCita
            paciente {
            persona {
            primerApellido
            primerNombre
            identificacion
            }}
            }
          }
          cantidad
          status
          message
       
        
      }
    }
  `;

  const variables = {
    idUser,
    
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    const result = response.data.data.consultarCantidadComentariosByAuditor;

    console.log("RESULTADOS REVISON COMENTARIOS", result)

    if (!result) return null;

    return result;
  } catch (error) {
    console.error(error);
    return null;
  }
};



export const atencionAuditoriaService = {
  getCommentsByAtencion,
  getCommentsValidacionByAtencion,
  updateComentarioValidacion,
  addComentarioAuditoria,
  consultarComentariosAuditoria,
  consultarCantidadComentariosAuditoria,
  changeToCorregidoAuditoria,
  changeToValidadoAuditoria,
  consultarCantidadComentariosByAuditor
};
